module.exports = __webpack_public_path__ + "img/5.08.thmb.f2838fc7.jpg";